"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleWindowMessage = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const handleError_1 = require("./handleError");
const listenForUpdates_1 = require("./listen-for-updates/listenForUpdates");
const volumeChannels_1 = require("../volumeChannels");
const state_1 = require("../state");
const handleWindowMessage = (message) => {
    if (typeof message === "object" &&
        message !== null &&
        "type" in message &&
        "value" in message &&
        typeof message.type === "string") {
        switch (message.type) {
            case "auth": {
                if (typeof message.value !== "string") {
                    throw new Error("Invalid auth message value.");
                }
                const url = state_1.state.values.serverURL;
                if (url === null) {
                    throw new Error("Attempted to connect to socket.io server with no server URL.");
                }
                (0, pixel_pigeon_1.connectToSocketioServer)({
                    auth: { token: message.value },
                    url,
                });
                (0, pixel_pigeon_1.onError)(handleError_1.handleError);
                (0, listenForUpdates_1.listenForUpdates)();
                break;
            }
            case "main-volume": {
                if (typeof message.value !== "number") {
                    throw new Error("Invalid main volume message value.");
                }
                (0, pixel_pigeon_1.setMainVolume)({
                    volume: message.value,
                });
                break;
            }
            case "music-volume": {
                if (typeof message.value !== "number") {
                    throw new Error("Invalid music volume message value.");
                }
                (0, pixel_pigeon_1.setVolumeChannelVolume)({
                    id: volumeChannels_1.musicVolumeChannelID,
                    volume: message.value,
                });
                break;
            }
            case "sfx-volume": {
                if (typeof message.value !== "number") {
                    throw new Error("Invalid sfx volume message value.");
                }
                (0, pixel_pigeon_1.setVolumeChannelVolume)({
                    id: volumeChannels_1.sfxVolumeChannelID,
                    volume: message.value,
                });
                break;
            }
        }
    }
};
exports.handleWindowMessage = handleWindowMessage;
